import { useEffect, useRef, useState } from "react";
import Subquery from "../components/subqueryadd";
import RQuill from "../components/quill_editor";
// import { uploadFile } from 'react-s3';
// import ReactQuill from 'react-quill';
import { Buffer } from "buffer";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  Input,
  Button,
  Typography,
  Row,
  Col,
  Tabs,
  Form,
  Dropdown,
  message,
  Menu,
  Avatar,
  List,
  Table,
  InputNumber,
  Select,
  DatePicker,
  theme
} from "antd";
import { Comment } from '@ant-design/compatible';
import {
  EllipsisOutlined,
  EditOutlined,
  DeleteOutlined,
  DownOutlined,
  RightOutlined,
  LeftCircleOutlined,
} from "@ant-design/icons";
import { BsChevronDown } from "react-icons/bs";
import useFetch from "../_fetch";
import { Loader } from "../components/loader";
import CommentView from "../components/commentView";
import Files from "../components/files";
// import { ChangeQuery } from "../store/action/queries";
import { useDispatch, useSelector } from "react-redux";
import Activity from "../components/activity";
import { query_type, user_role } from "../consts";
import PermissionModal from "../components/PermissionModal";
import SubQueryModal from "../components/SubQueryModal";
import moment from "moment";
import { useGetAllClients, useGetAllFinancialYears, useDeleteQuery } from "../utils/queryUtils";
import { setReloadQuery } from "../store/action/reload";
import { trackEvent } from "../utils/mixpanel";
import { useIsPrimaryClientView } from "../utils/useIsPrimaryClientView";
// import { changeSelectedClient } from "../store/action/client";
// import { changeSelectedFY } from "../store/action/fy";

var cc = require("currency-codes");
var QuillDeltaToHtmlConverter =
  require("quill-delta-to-html").QuillDeltaToHtmlConverter;

export default function Query(props) {
  const quillContent = useRef({ content: {}, html: "" });
  const myRef = useRef(null);
  const selectedFy = useSelector((st) => st.selected.fy);
  const [showquery, setShowquery] = useState(false);
  const [shownewquery, setShownewquery] = useState(false);
  const { mutateAsync: deleteCacheQuery } = useDeleteQuery();
  const [query, setQuery] = useState({});
  const displayDesc = useRef();
  const [loading, setLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [subQueries, setSubQueries] = useState([]);
  const [addQuery, setAddQuery] = useState(false);
  // const [subQueryComments, setSubQueryComments] = useState([]);
  const [editQuery, setEditQuery] = useState(false);
  const [permissionModalOpen, setPermissionModalOpen] = useState(null);
  const { token: { colorPrimary } } = theme.useToken();
  const [newSubQueryComment, setNewSubQueryComment] = useState("");
  const [subQueryFilesWaiting, setSubQueryFilesWaiting] = useState(false);
  const [parentModalQueryId, setParentModalQueryId] = useState(null);
  const [activeKey, setActiveKey] = useState([]);
  const { role } = useSelector((st) => st.user);
  const { isReadOnly } = useIsPrimaryClientView();

  const clientsdatawithpagination = useGetAllClients();
  const client = clientsdatawithpagination?.data?.response;
  const selectedPrimaryClient = useSelector((st) => st.selected.primaryClient);
  const { data: fy } = useGetAllFinancialYears();

  const currencyCodes = cc.codes();
  const currencyOptions = currencyCodes.map((code) => {
    return {
      label: code,
      value: code,
    };
  });

  const displayQueries = () => {
    setShowquery(true);
  };
  const displaynewqueries = () => {
    setShownewquery(true);
  };
  const navigate = useNavigate();
  // const currencyCodes = cc.codes();
  // const currencyOptions = currencyCodes.map((code) => {
  //     return {
  //         label: code,
  //         value: code
  //     };
  // });


  const _fetch = useFetch();
  const [form] = Form.useForm();
  let { queryId: query_id, companyName, clientName, fy: selectedFinancialYear } = useParams();
  if (props.query) {
    query_id = props.query;
  }
  let { setModalQueryId, onSuccess } = props;
  const dispatch = useDispatch();

  const init = async () => {

    try {
      const primaryClientParam = selectedPrimaryClient?._id
        ? `&primary_client_id=${selectedPrimaryClient._id}`
        : '';
      let res = await _fetch(
        `${process.env.REACT_APP_API_URL}/query/${query_id}`
      );
      let result = await res.json();
      if (res.status === 200) {
        result.descriptionV2 = result.descriptionV2.map(dv2 => !("insert" in dv2) ? ({ insert: "", ...dv2 }) : dv2)
        setQuery(result);
        if (result) {
          var converter = new QuillDeltaToHtmlConverter(
            result.descriptionV2,
            []
          );
          displayDesc.current = converter.convert();
        } else displayDesc.current = result.description;


        let commRes = await _fetch(
          `${process.env.REACT_APP_API_URL}/comment?query=${result?._id}${primaryClientParam}`
        );
        if (commRes.status === 200) {
          commRes = await commRes.json();
          setComments(commRes.result);
        }
        await loadSubQueries();
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const loadSubQueries = async () => {
    try {
      let res = await _fetch(
        `${process.env.REACT_APP_API_URL}/query/${query_id}?sub=true`
      );
      let result = await res.json();
      let commentData = [];
      for (let i = 0; i < result.length; i++) {
        let commRes = await _fetch(
          `${process.env.REACT_APP_API_URL}/comment?query=${result[i]?._id}`
        );
        if (commRes.status === 200) {
          commRes = await commRes.json();
          result[i] = { ...result[i], comments: commRes?.result?.slice(0, 2), key: i };
        }
      }
      setSubQueries(result);
    } catch (e) {
    }
  };

  useEffect(() => {
    init();
  }, [query_id,selectedPrimaryClient?._id]);

  const columns = [
    {
      title: "Narration",
      key: "narration",
      dataIndex: "title",
      render: (text) => (
        <Typography.Title
          level={5}
          style={{
            userSelect: "none",
          }}
        >
          {text}
        </Typography.Title>
      ),
    },
    {
      title: "Cash In",
      key: "cashIn",
      render: (record) => {
        return `${record.cashIn?.value || 0} ${record.cashIn?.currency || ""}`;
      },
    },
    {
      title: "Cash Out",
      key: "cashOut",
      render: (record) => {
        return `${record.cashOut?.value || 0} ${record.cashOut?.currency || ""
          }`;
      },
    },
    {
      title: "Date",
      key: "date",
      render: (record) => {
        return `${moment(record.Date).format('YYYY-MMM-DD') || ""}`;
      },
    },
    {
      title: "Status",
      key: "action",
      render: (record) => <QueryStatus queryObj={record} />,
    },
  ];

  async function uploadPhotos(op) {
    let url = await _fetch(
      `${process.env.REACT_APP_API_URL}/file/get_upload_url?name=${query_id}_${moment().format("MMDDYYYYhhmmss")}.jpeg&query=${query._id}`
    );
    if (url.status === 200) {
      url = await url.json();
    } else {
      throw new Error("url to upload generation failed");
    }

    var buf = new Buffer.from(
      op.insert.image.replace(/^data:image\/\w+;base64,/, ""),
      "base64"
    );
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": "image/jpeg",
      },
      body: buf,
    };
    let res = await fetch(url, options);
    if (res.status === 200) {
      try {
        let parsedUrl = new URL(url);
        let pathname = parsedUrl.pathname.slice(1);
        let fileInDB = await _fetch(`${process.env.REACT_APP_API_URL}/file`, {
          method: "POST",
          body: {
            query: query._id,
            path: pathname,
            type: "image/jpeg",
          },
        });
        if (fileInDB.status >= 200 && fileInDB.status < 300) {
          fileInDB = await fileInDB.json();
          op.insert.image = `${process.env.REACT_APP_API_URL}/file/get_object?id=${fileInDB._id}`;
          return op;
        }
      } catch (e) {
        console.error(e);
        return {};
      }
    }
    return {};
  }

  const handleQueryUpdate = async (update) => {
    if (update.cashInValue >= 0 && update.cashInCurrency) {
      const cashIn = {
        value: update.cashInValue,
        currency: update.cashInCurrency,
      };
      delete update.cashInValue;
      delete update.cashInCurrency;
      update.cashIn = cashIn;
    }
    if (update.cashOutValue >= 0 && update.cashOutCurrency) {
      const cashOut = {
        value: update.cashOutValue,
        currency: update.cashOutCurrency,
      };
      delete update.cashOutValue;
      delete update.cashOutCurrency;
      update.cashOut = cashOut;
    }
    let body = update;

    let { ops } = quillContent.current.content;
    if (ops) {
      let descriptionV2 = [];
      for (let i = 0; i < ops.length; i++) {
        if (ops[i].insert.image && !ops[i].insert.image.includes("http")) {
          let j = await uploadPhotos(ops[i]);
          descriptionV2.push(j);
        } else descriptionV2.push(ops[i]);
      }
      body = { ...body, descriptionV2, description: "" };
    }
    let updatedQuery = await _fetch(
      `${process.env.REACT_APP_API_URL}/query/${query?._id}`,
      {
        method: "PATCH",
        body,
      }
    );
    let resJson = await updatedQuery.json();
    if (resJson) {
      message.success("Query Updated");
      setQuery(resJson);
      dispatch(setReloadQuery(true))
      var converter = new QuillDeltaToHtmlConverter(
        resJson?.descriptionV2,
        []
      );
      displayDesc.current = converter.convert();
      // dispatch(ChangeQuery(resJson.response));
      setEditQuery(false);
    }
  };

  const handleQueryStatusUpdate = async (update, queryObj) => {
    if (update?.status === queryObj?.status) return;
    try {
      setLoading(true);
      let body = update;
      let updatedQuery = await _fetch(
        `${process.env.REACT_APP_API_URL}/query/${queryObj._id}`,
        {
          method: "PATCH",
          body,
        }
      );
      let resJson = await updatedQuery.json();
      if (resJson) {
        message.success("Status Updated");
        // await dispatch(ChangeQuery(resJson.response));
        await init();
        await loadSubQueries();
        dispatch(setReloadQuery(true))
      } else {
        message.error("Status Update Failed");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleQuill = (content, delta, source, editor) => {

    quillContent.current.content = editor.getContents();
    quillContent.current.html = editor.getHTML();
  };

  function QueryForm() {
    return (
      <Form className="w-100" onFinish={handleQueryUpdate} form={form}>
        <div className="d-flex w-100 justify-content-between align-items-center">
          <Form.Item className="w-75" name="title" initialValue={query.title}>
            <Input
              value={query.title}
              size="large"
              autoFocus
              variant="borderless"
              style={{
                fontSize: "30px",
                border: 0,
              }}
            />
          </Form.Item>
          <Form.Item>
            <Button
              onClick={() => setEditQuery(false)}
              size="large"
              style={{ fontSize: "12px", marginRight: "10px" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{ fontSize: "12px" }}
            >
              Update
            </Button>
          </Form.Item>
        </div>
        <div className="d-flex flex-column align-items-start my-4">
          <Typography.Title level={5}>Description</Typography.Title>
          <RQuill
            onChange={handleQuill}
            queryID={query._id}
            initValue={
              query.descriptionV2?.length
                ? query.descriptionV2
                : query.description
            }
          />
        </div>
        {query.type === query_type.TRANSACTIONAL && (
          <div className="d-flex w-100 flex-column align-items-start my-4">
            <div className="w-100">
              <Typography.Title level={5}>Transaction Details</Typography.Title>
              <Row justify={"space-evenly"} gutter={[16, 0]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                  <Form.Item
                    name="cashInValue"
                    label="Cash In"
                    initialValue={query.cashIn?.value}
                    labelAlign="right"
                    labelCol={{
                      span: 8,
                    }}
                    wrapperCol={{
                      span: 16,
                    }}
                  >
                    <InputNumber
                      style={{ width: "200px" }}
                      size="medium"
                      placeholder="Cash In"
                      className="mr-5"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                  <Form.Item
                    name="cashInCurrency"
                    label="Cash In Currency"
                    initialValue={query.cashIn?.currency}
                    labelAlign="right"
                    labelCol={{
                      span: 8,
                    }}
                    wrapperCol={{
                      span: 16,
                    }}
                  >
                    <Select
                      showSearch
                      placeholder="Select a currency"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      options={currencyOptions}
                      style={{ width: "200px" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify={"space-evenly"} gutter={[16, 0]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                  <Form.Item
                    name="cashOutValue"
                    label="Cash Out"
                    initialValue={query.cashOut?.value}
                    labelAlign="right"
                    labelCol={{
                      span: 8,
                    }}
                    wrapperCol={{
                      span: 16,
                    }}
                  >
                    <InputNumber
                      style={{ width: "200px" }}
                      size="medium"
                      placeholder="Cash Out"
                      className="mr-5"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                  <Form.Item
                    name="cashOutCurrency"
                    label="Cash Out Currency"
                    initialValue={query.cashOut?.currency}
                    labelAlign="right"
                    labelCol={{
                      span: 8,
                    }}
                    wrapperCol={{
                      span: 16,
                    }}
                  >
                    <Select
                      showSearch
                      placeholder="Select a currency"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "").includes(input)
                      }
                      options={currencyOptions}
                      style={{ width: "200px" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} style={{ marginLeft: "-42px" }}
                >
                  <Form.Item name='Date' label='Date' initialValue={query?.Date ? moment(query?.Date) : '0'} labelAlign='right' labelCol={{
                    span: 8,
                  }} wrapperCol={{
                    span: 16,
                  }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <DatePicker format="YYYY-MM-DD" style={{ width: '180px' }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12} ></Col>
              </Row>
            </div>
          </div>
        )}
      </Form>
    );
  }
  async function deleteQuery() {
    try {
      let resJson = await deleteCacheQuery(permissionModalOpen._id);
      if (resJson) {
        setPermissionModalOpen(null);
        message.success("Query Deleted Successfully");
        dispatch(setReloadQuery(true));

        if (setModalQueryId) {
          setModalQueryId(null);
          onSuccess();
        } else {
          navigate(`/${companyName}/${clientName}/${selectedFinancialYear}?tab=queries`);
        }
      } else {
        message.error("Failed to delete query");
        setPermissionModalOpen(null);
      }
    } catch (err) {
      console.error(err);
      message.error("Some error occurred while deleting query");
      setPermissionModalOpen(null);
    }
  }

  async function handleNewSubQueryComment(subQuery) {
    var payload = {
      query: subQuery._id,
      text: newSubQueryComment,
    };
    try {
      let res = await _fetch(`${process.env.REACT_APP_API_URL}/comment`, {
        method: "POST",
        body: {
          ...payload,
        },
      });

      if (res.status === 201) {
        res = await res.json();
        message.success("Comment Added Successfully");
        setNewSubQueryComment("");
        setSubQueryFilesWaiting(false);
        trackEvent("Add Comment", {
          "_id": res._id,
          "query_id": subQuery?._id,
          "company": companyName || "",
          "client": clientName || "",
          "fy": selectedFinancialYear || "",
          "comment_id": res?._id,
          "text": res.text
        })
        if (subQuery?.status === "CLOSED") {
          await handleQueryStatusUpdate({ status: "OPEN" }, subQuery);
        } else {
          // await loadSubQueries();
          setSubQueries(() => {
            return subQueries.map((subQueryObj) => {
              if (subQueryObj._id === subQuery._id) {
                return { ...subQueryObj, comments: [...subQueryObj.comments, res] }
              }
              return subQueryObj
            })
          })
        }
        return res._id;
      }
    } catch (e) {
      console.error(e);
      message.error("Some error occurred while adding comment");
    }
  }

  function QueryStatus({ queryObj }) {
    const statusMenu = (
      <Menu
        items={[
          {
            key: 'open',
            label: 'Open',
            onClick: () => handleQueryStatusUpdate({ status: 'OPEN' }, queryObj),
          },
          {
            key: 'closed',
            label: 'Closed',
            onClick: () => handleQueryStatusUpdate({ status: 'CLOSED' }, queryObj),
          },
        ]}
      />

    );

    return (
      <div>
        {role === user_role.COMPANY ? (
          <Button
            type="primary"
            danger={queryObj.status === "CLOSED"}
            className="mx-auto"
          >
            {queryObj.status}
          </Button>
        ) : (
          <Dropdown
            trigger={["click"]}
            overlay={statusMenu}
            disabled={isReadOnly}
            arrow
            onClick={(e) => e.stopPropagation()}
          >
            <Button
              style={{
                background: queryObj.status === "CLOSED" ? "green" : colorPrimary,
                borderColor: queryObj.status === "CLOSED" ? "green" : null,
              }}
              type="primary"
              className="d-flex justify-content-between"
            >
              {queryObj.status}
              <BsChevronDown size={20} />
            </Button>
          </Dropdown>
        )}
      </div>
    );
  }


  return (
    <>
      <Card
        className="header-solid h-full mb-24"
        variant="borderless"
        style={{ body: { height: "100%", marginBottom: "24px" } }}
      >
        {loading ? (
          <Loader />
        ) : query_id ? (
          <Row gutter={[10, 10]} className="h-100">
            <Col span={24}>
              <div className="p-2 h-auto">
                {editQuery ? (
                  <QueryForm />
                ) : (
                  <div>
                    {
                      setModalQueryId && (
                        <div
                          className="d-flex flex-row align-items-center justify-content-start"
                        >
                          <LeftCircleOutlined
                            onClick={() => {
                              if (parentModalQueryId) {
                                setModalQueryId(parentModalQueryId)
                                setParentModalQueryId(null)
                              } else {
                                setModalQueryId(null)
                              }
                            }}
                            style={{
                              fontSize: '25px',
                              cursor: 'pointer',
                              color: colorPrimary
                            }}
                          />
                          <Typography.Text
                            style={{
                              marginLeft: '10px'
                            }}
                          >
                            <b>Query ID:</b> {query_id}
                          </Typography.Text>
                        </div>
                      )
                    }
                    <div className="d-flex w-100 justify-content-between align-items-center">
                      <div
                        className="d-flex flex-row align-items-center justify-content-start"
                      >
                        {
                          !setModalQueryId && (
                            <LeftCircleOutlined
                              onClick={() => {
                                navigate(-1);
                              }}
                              style={{
                                fontSize: '25px',
                                cursor: 'pointer',
                                color: colorPrimary,
                                marginRight: '10px'
                              }}
                            />
                          )
                        }
                        <Typography.Title level={2} className="my-auto">
                          {query?.title}
                        </Typography.Title>
                      </div>
                      {subQueries.length === 0 && query?.type === query_type.NORMAL && (
                        <Button
                          style={{
                            position: "absolute",
                            right: "160px",
                            color: colorPrimary
                          }}
                          onClick={() => displayQueries()}
                          type="link"
                          disabled={isReadOnly}
                        >
                          + Add Transactional Query
                        </Button>
                      )}

                      <Row>
                        <QueryStatus queryObj={query} />
                        {role !== user_role.COMPANY && (
                          <Dropdown
                            disabled={isReadOnly}
                            trigger={["click"]}
                            overlay={
                              <Menu>
                                {role !== user_role.COMPANY && (
                                  <Menu.Item
                                    onClick={() => {
                                      setEditQuery(true);
                                    }}
                                    disabled={query?.status === "CLOSED"}
                                  >
                                    <Row style={{ alignItems: "center" }}>
                                      <EditOutlined
                                        style={{
                                          color: colorPrimary,
                                          fontSize: "20px",
                                          marginRight: "5px",
                                        }}
                                      />
                                      Edit
                                    </Row>
                                  </Menu.Item>
                                )}
                                {(role === user_role.ADMIN || role === user_role.STAFF) && (
                                  <Menu.Item
                                    onClick={() => {
                                      setPermissionModalOpen(query);
                                    }}
                                    disabled={query?.status === "CLOSED"}
                                  >
                                    <Row style={{ alignItems: "center" }}>
                                      <DeleteOutlined
                                        style={{
                                          color: "red",
                                          fontSize: "20px",
                                          marginRight: "5px",
                                        }}
                                      />
                                      Delete
                                    </Row>
                                  </Menu.Item>
                                )}
                                { }
                              </Menu>
                            }
                          >
                            <Button
                              type="link"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <EllipsisOutlined
                                style={{
                                  fontSize: "20px",
                                  color: "black",
                                }}
                              />
                            </Button>
                          </Dropdown>
                        )}
                      </Row>
                    </div>
                    <div className="d-flex flex-column align-items-start my-4">
                      <Typography.Title level={5}>Description</Typography.Title>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: displayDesc.current,
                        }}
                        style={{ whiteSpace: "pre-line" }}
                      />
                    </div>
                    {query?.type === query_type.TRANSACTIONAL && (
                      <div className="d-flex flex-column align-items-start my-4">
                        <Typography.Title level={5}>
                          Transaction Details
                        </Typography.Title>
                        <Typography.Text>
                          {`Cash In: ${query.cashIn?.value || 0} ${query.cashIn?.currency || ""
                            }`}
                        </Typography.Text>
                        <Typography.Text>
                          {`Cash Out: ${query.cashOut?.value || 0} ${query.cashOut?.currency || ""
                            }`}
                        </Typography.Text>
                        <Typography.Text>
                          {`Date: ${query.Date !== undefined ? moment(query.Date).format(
                            "DD MMM YYYY"
                          ) : ""} `}
                        </Typography.Text>
                      </div>
                    )}
                  </div>
                )}
                <div>
                  <Typography.Title
                    level={5}
                    className="align-self-start"
                    disabled={query?.status === "CLOSED"}
                  >
                    Files
                  </Typography.Title>
                  <Files
                    setQuery={setQuery}
                    query={query}
                    query_id={query_id}
                    id={query?._id}
                    queryStatus={query?.status}
                  />
                </div>

                {/* // subQueries.length > 0 && */}
                {(subQueries.length > 0 || showquery) && (
                  <div
                    style={{
                      marginTop: "15px",
                    }}
                  >
                    <Row
                      style={{
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                      gutter={[8, 0]}
                    >
                      <Col>
                        <Typography.Title
                          level={5}
                          style={{
                            margin: 0,
                          }}
                        >
                          Sub Query
                        </Typography.Title>
                      </Col>
                      {!setModalQueryId && <Col>{ }</Col>}
                      {subQueries.length > 0 && query.type === query_type.NORMAL && (
                        <Button onClick={() => displaynewqueries()} type="link" style={{ color: colorPrimary }} disabled={isReadOnly}>
                          {" "}
                          + ADD Transactional Query
                        </Button>
                      )}
                    </Row>
                    <Card
                      className="header-solid h-full mb-15 mt-15"
                      variant="outlined"
                    >
                      {subQueries.length == 0 && (
                        <div ref={myRef}>
                          <Subquery
                            subQueries={subQueries}
                            setSubQueries={setSubQueries}
                            myref={myRef}
                            query={query}
                            query_type={query_type}
                            onSuccess={onSuccess}
                            setShownewquery={setShownewquery}
                          />
                        </div>
                      )}
                      {/* .................add queriessssssssssssssssssssssssssss .........*/}
                      {subQueries.length > 0 && (
                        <div>
                          <Table
                            style={{ width: "100%" }}
                            columns={columns}
                            dataSource={subQueries}
                            pagination={false}
                            size="small"
                            loading={loading}
                            expandable={{
                              expandedRowRender: (subQuery) => (
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div
                                      style={{ width: "70%" }}
                                      className="d-flex flex-row align-items-center justify-content-around"
                                    >
                                      <Input.TextArea
                                        id="subQueryComment"
                                        placeholder="Add a comment"
                                        autoSize={{
                                          minRows: 2,
                                          maxRows: 3,
                                        }}
                                        value={newSubQueryComment}
                                        onChange={(e) => {
                                          setNewSubQueryComment(e.target.value);
                                        }}
                                      />
                                      {(newSubQueryComment ||
                                        subQueryFilesWaiting) && (
                                          <div>
                                            <Button
                                              type="text"
                                              disabled={isReadOnly}
                                              onClick={() => {
                                                setNewSubQueryComment("");
                                              }}
                                              size="small"
                                              style={{
                                                margin: "0 5px",
                                              }}
                                            >
                                              Cancel
                                            </Button>
                                            <Button
                                              type="primary"
                                              disabled={isReadOnly}
                                              onClick={async () => {
                                                await handleNewSubQueryComment(
                                                  subQuery
                                                );
                                              }}
                                              size="small"
                                              style={{
                                                margin: "0 5px",
                                              }}
                                            >
                                              Submit
                                            </Button>
                                          </div>
                                        )}
                                    </div>
                                    <div>
                                      <Button
                                        type="primary"
                                        onClick={() => {
                                          if (setModalQueryId) {
                                            setModalQueryId(subQuery.query_id);
                                            setParentModalQueryId(query_id);
                                          } else {
                                            navigate(`/query/${subQuery.query_id}`);
                                          }
                                        }}
                                      >
                                        View more
                                      </Button>
                                    </div>
                                  </div>
                                  {/* <UploadSnapshot
                                                                    setFilesWaiting={setSubQueryFilesWaiting}
                                                                    refresh={reset}
                                                                    id={subQuery._id}
                                                                    containerId = {'subQueryComment'}
                                                                /> */}
                                  {subQuery.comments?.length ? (
                                    <List
                                      className="comment-list w-100 px-3"
                                      itemLayout="horizontal"
                                      dataSource={subQuery.comments}
                                      loadMore={
                                        <div
                                          style={{
                                            textAlign: "center",
                                          }}
                                        >
                                          <Files
                                            id={subQuery._id}
                                            queryStatus={subQuery.status}
                                          />
                                        </div>
                                      }
                                      renderItem={(item) => (
                                        <Comment
                                          author={
                                            <span>
                                              <b>
                                                {item?.created_by?.first_name}{" "}
                                                {item?.created_by?.last_name}
                                              </b>
                                              <span className="ms-2">
                                                {moment(item.createdAt).format(
                                                  "DD MMM YYYY HH:mm"
                                                )}
                                              </span>
                                            </span>
                                          }
                                          avatar={
                                            <Avatar shape="square">
                                              {item?.created_by?.first_name}
                                              {item?.created_by?.last_name}
                                            </Avatar>
                                          }
                                          content={
                                            <div>
                                              <span
                                                style={{
                                                  whiteSpace: "pre-line",
                                                }}
                                              >
                                                {" "}
                                                {item?.text}
                                              </span>

                                              {/* <div>
                                                {files.filter(
                                                  (s) =>
                                                    s.commentId === item._id
                                                ).length
                                                  ? files
                                                    .filter(
                                                      (s) =>
                                                        s.commentId ===
                                                        item._id
                                                    )
                                                    .map((e) => (
                                                      <Tag
                                                        className="pointer m-1"
                                                        style={{
                                                          padding: "9px",
                                                          borderRadius: "5px",
                                                          maxWidth: "180px",
                                                        }}
                                                      >
                                                        <Image src={e.path} />
                                                        <div>
                                                          {(() => {
                                                            e.name =
                                                              e.name.split(
                                                                "---"
                                                              )[0];
                                                            const changedName =
                                                              e.name.length <=
                                                                15
                                                                ? `${e.name}`
                                                                : `${e.name
                                                                  .split(
                                                                    "."
                                                                  )[0]
                                                                  .slice(
                                                                    0,
                                                                    12
                                                                  )}...${e.name.split(
                                                                    "."
                                                                  )[1]
                                                                }`;

                                                            return changedName;
                                                          })()}
                                                        </div>
                                                        <div>
                                                          {moment
                                                            .utc(e.createdAt)
                                                            .format(
                                                              "DD MMM YYYY HH:mm"
                                                            )}
                                                        </div>
                                                      </Tag>
                                                    ))
                                                  : null}
                                              </div> */}
                                            </div>
                                          }
                                        />
                                      )}
                                    />
                                  ) : null}
                                </div>
                              ),
                              expandedRowKeys: activeKey,
                              onExpand: (expanded, record) => {
                                if (expanded) {
                                  setActiveKey([record.key]);
                                } else {
                                  setActiveKey([]);
                                }
                                setSubQueryFilesWaiting(false);
                                setNewSubQueryComment("");
                              },

                              rowExpandable: (record) =>
                                record?.title !== "Not Expandable",
                              expandRowByClick: true,
                              expandIcon: ({ expanded, onExpand, record }) =>
                                expanded ? (
                                  <DownOutlined
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onExpand(record, e);
                                    }}
                                  />
                                ) : (
                                  <RightOutlined
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onExpand(record, e);
                                    }}
                                  />
                                ),
                            }}
                          />
                        </div>
                      )}
                      {subQueries.length > 0 && shownewquery && (
                        <div ref={myRef}>
                          <Subquery
                            subQueries={subQueries}
                            setSubQueries={setSubQueries}
                            myref={myRef}
                            query={query}
                            query_type={query_type}
                            onSuccess={onSuccess}
                            setShownewquery={setShownewquery}
                          />
                        </div>
                      )}
                    </Card>

                    <div></div>
                  </div>
                )}
                <Tabs
                  type="card"
                  className="my-4"
                  items={[
                    {
                      key: "comments",
                      label: (
                        <Typography.Title level={5} className="align-self-start">
                          Comments
                        </Typography.Title>
                      ),
                      children: (
                        <CommentView
                          comments={comments}
                          queryId={query?._id}
                          fy={selectedFy?._id}
                          sendEmail={false}
                          setComments={setComments}
                          onCommentAdded={query.status === "CLOSED" ? handleQueryUpdate : null}
                        />
                      ),
                    },
                    {
                      key: "history",
                      label: (
                        <Typography.Title level={5} className="align-self-start">
                          History
                        </Typography.Title>
                      ),
                      children: <Activity query_id={query._id} canNavigate={false} />,
                    },
                  ]}
                />

              </div>
            </Col>
          </Row>
        ) : (
          <div className="py-3 px-3">
            <Typography.Title level={3}>
              The Query does not exist or you do not have access :/
            </Typography.Title>
          </div>
        )}
      </Card>
      <PermissionModal
        visible={permissionModalOpen !== null}
        setVisible={setPermissionModalOpen}
        onSuccess={deleteQuery}
        child={
          <p>
            Are you sure you want to delete this <b>Query</b>? This will delete
            all the <b>Attachments</b> related to this Query.
          </p>
        }
      />
      <SubQueryModal
        visible={addQuery}
        setVisible={setAddQuery}
        onSuccess={loadSubQueries}
        query={query}
      />
    </>
  );
}
